// JavaScript cho menu sidebar cố định bên trái
document.addEventListener('DOMContentLoaded', function() {
  // Chỉ chạy trên trang menu collection
  if (window.location.pathname.includes('/collections/menu')) {
    // Tạo menu sidebar trigger (nút bên trái)
    const sidebarTrigger = document.createElement('div');
    sidebarTrigger.className = 'fixed-sidebar-trigger';
    
    const triggerText = document.createElement('div');
    triggerText.className = 'text';
    triggerText.textContent = 'Thực đơn';
    
    const triggerIcon = document.createElement('div');
    triggerIcon.className = 'icon';
    triggerIcon.innerHTML = '!!!';
    
    sidebarTrigger.appendChild(triggerText);
    sidebarTrigger.appendChild(triggerIcon);
    
    // Tạo overlay
    const overlay = document.createElement('div');
    overlay.className = 'fixed-sidebar-overlay';
    
    // Tạo sidebar
    const sidebar = document.createElement('div');
    sidebar.className = 'fixed-sidebar';
    
    // Tạo header cho sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'fixed-sidebar-header';
    
    const sidebarTitle = document.createElement('h3');
    sidebarTitle.className = 'fixed-sidebar-title';
    sidebarTitle.textContent = 'Thực đơn';
    
    const closeBtn = document.createElement('div');
    closeBtn.className = 'fixed-sidebar-close';
    closeBtn.innerHTML = '&times;';
    
    sidebarHeader.appendChild(sidebarTitle);
    sidebarHeader.appendChild(closeBtn);
    
    // Tạo menu
    const sidebarMenu = document.createElement('ul');
    sidebarMenu.className = 'fixed-sidebar-menu';
    
    // Danh sách các mục menu
    const menuItems = [
      { id: 'combo', name: 'Combo', img: 'https://sushiway25.myshopify.com/cdn/shop/files/tempura-tong-hop-1.jpg' },
      { id: 'fusion', name: 'Fusion', img: 'https://sushiway25.myshopify.com/cdn/shop/files/ca-cam-sashimi-kieu-y.jpg' },
      { id: 'sashimi', name: 'Sashimi', img: 'https://sushiway25.myshopify.com/cdn/shop/files/sashimi-ca-hoi_1.jpg' },
      { id: 'zensai-khai-vi', name: 'Zensai - Khai vị', img: 'https://sushiway25.myshopify.com/cdn/shop/files/xa-lach-bo-ca-hoi-1.jpg' },
      { id: 'agemono-mon-chien', name: 'Agemono - Món chiên', img: 'https://sushiway25.myshopify.com/cdn/shop/files/tom-tuoi-chien-tempura-1.jpg' },
      { id: 'yaki-mon-nuong', name: 'Yaki - Món nướng', img: 'https://sushiway25.myshopify.com/cdn/shop/files/ca-hoi-nuong-muoi-1.jpg' },
      { id: 'sushi', name: 'Sushi', img: 'https://sushiway25.myshopify.com/cdn/shop/files/roll-ca-hoi-xot-cay-1.jpg' },
      { id: 'bento', name: 'BENTO - PHỤC VỤ BUỔI TRƯA', img: 'https://sushiway25.myshopify.com/cdn/shop/files/ca-hoi-ap-chao-xot-teriyaki-xa-lach-sup-com-nhat-1.jpg' },
      { id: 'donburi', name: 'Donburi - Cơm Nhật', img: 'https://sushiway25.myshopify.com/cdn/shop/files/com-chien-ca-hoi-1.jpg' },
      { id: 'mi-udon-ramen', name: 'Mì Udon & Ramen', img: 'https://sushiway25.myshopify.com/cdn/shop/files/udon-xao-hai-san-2.jpg' },
      { id: 'extra', name: 'Extra', img: 'https://sushiway25.myshopify.com/cdn/shop/files/COM-TRANG.webp' },
      { id: 'thuc-uong', name: 'Thức uống', img: 'https://sushiway25.myshopify.com/cdn/shop/files/Mijinda-1.jpg' }
    ];
    
    // Tạo các mục menu
    menuItems.forEach(item => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + item.id;
      a.setAttribute('data-category', item.id);
      a.className = 'sidebar-menu-item';
      
      const img = document.createElement('img');
      img.src = item.img;
      img.alt = item.name;
      
      a.appendChild(img);
      a.appendChild(document.createTextNode(item.name));
      
      li.appendChild(a);
      sidebarMenu.appendChild(li);
    });
    
    // Ráp sidebar lại
    sidebar.appendChild(sidebarHeader);
    sidebar.appendChild(sidebarMenu);
    
    // Thêm các phần tử vào body
    document.body.appendChild(sidebarTrigger);
    document.body.appendChild(sidebar);
    document.body.appendChild(overlay);
    
    // Thêm ID cho các section sản phẩm
    function addIdsToProductSections() {
      // Tìm các heading hoặc các phần nội dung chứa tên danh mục
      const productGroups = document.querySelectorAll('.product-group, .collection-section, .section, section, .product-list, .product-category, [class*="products"], [class*="collection"]');
      
      productGroups.forEach(group => {
        const headings = group.querySelectorAll('h1, h2, h3, h4, .product-title, .section-title, .heading');
        
        // Duyệt qua từng heading
        for (let i = 0; i < headings.length; i++) {
          const heading = headings[i];
          if (!heading || !heading.textContent) continue;
          
          const text = heading.textContent.trim().toLowerCase();
          
          // Xác định ID dựa trên nội dung
          if (text.includes('combo')) {
            group.id = 'combo';
            break;
          } else if (text.includes('fusion')) {
            group.id = 'fusion';
            break;
          } else if (text.includes('sashimi') || text.includes('shashimi')) {
            group.id = 'sashimi';
            break;
          } else if (text.includes('zensai') || text.includes('khai vị')) {
            group.id = 'zensai-khai-vi';
            break;
          } else if (text.includes('agemono') || text.includes('món chiên')) {
            group.id = 'agemono-mon-chien';
            break;
          } else if (text.includes('yaki') || text.includes('món nướng')) {
            group.id = 'yaki-mon-nuong';
            break;
          } else if (text.includes('sushi') && !text.includes('sashimi')) {
            group.id = 'sushi';
            break;
          } else if (text.includes('bento') || (text.includes('phục vụ') && text.includes('trưa'))) {
            group.id = 'bento';
            break;
          } else if (text.includes('donburi') || (text.includes('cơm') && text.includes('nhật'))) {
            group.id = 'donburi';
            break;
          } else if (text.includes('udon') || text.includes('ramen') || (text.includes('mì') && (text.includes('udon') || text.includes('ramen')))) {
            group.id = 'mi-udon-ramen';
            break;
          } else if (text.includes('extra')) {
            group.id = 'extra';
            break;
          } else if (text.includes('thức uống') || text.includes('đồ uống') || text.includes('nước')) {
            group.id = 'thuc-uong';
            break;
          }
        }
      });
      
      // Thêm IDs thủ công nếu không thể tìm thấy từ tiêu đề
      // Tìm tất cả các sản phẩm và nhóm sản phẩm khác
      const allProducts = document.querySelectorAll('.product, .product-item');
      
      allProducts.forEach(product => {
        const productTitle = product.querySelector('.product-title, .title, h3, h4');
        if (!productTitle || !productTitle.textContent) return;
        
        const text = productTitle.textContent.trim().toLowerCase();
        const parentSection = product.closest('section') || product.closest('.section') || product.closest('[class*="products"]') || product.closest('[class*="collection"]');
        
        if (!parentSection || parentSection.id) return;
        
        // Gán ID cho phần cha dựa trên loại sản phẩm đầu tiên tìm thấy
        if (text.includes('combo')) {
          parentSection.id = 'combo';
        } else if (text.includes('fusion')) {
          parentSection.id = 'fusion';
        } else if (text.includes('sashimi') || text.includes('shashimi')) {
          parentSection.id = 'sashimi';
        } else if (text.includes('zensai') || text.includes('khai vị')) {
          parentSection.id = 'zensai-khai-vi';
        } else if (text.includes('agemono') || text.includes('món chiên')) {
          parentSection.id = 'agemono-mon-chien';
        } else if (text.includes('yaki') || text.includes('món nướng')) {
          parentSection.id = 'yaki-mon-nuong';
        } else if (text.includes('sushi') && !text.includes('sashimi')) {
          parentSection.id = 'sushi';
        } else if (text.includes('bento')) {
          parentSection.id = 'bento';
        } else if (text.includes('donburi') || (text.includes('cơm') && text.includes('nhật'))) {
          parentSection.id = 'donburi';
        } else if (text.includes('udon') || text.includes('ramen') || text.includes('mì')) {
          parentSection.id = 'mi-udon-ramen';
        } else if (text.includes('extra')) {
          parentSection.id = 'extra';
        } else if (text.includes('thức uống') || text.includes('đồ uống') || text.includes('nước')) {
          parentSection.id = 'thuc-uong';
        }
      });
      
      // Cân chỉnh margin-top cho các section để tránh bị che bởi header cố định
      document.querySelectorAll('[id^="combo"], [id^="fusion"], [id^="sashimi"], [id^="zensai"], [id^="agemono"], [id^="yaki"], [id^="sushi"], [id^="bento"], [id^="donburi"], [id^="mi-udon"], [id^="extra"], [id^="thuc-uong"]').forEach(section => {
        if (section) {
          section.style.scrollMarginTop = '100px';
        }
      });
    }
    
    // Thực hiện thêm ID cho các section
    addIdsToProductSections();
    
    // Xử lý sự kiện mở sidebar
    sidebarTrigger.addEventListener('click', function() {
      sidebar.classList.add('open');
      overlay.classList.add('visible');
      document.body.style.overflow = 'hidden'; // Ngăn cuộn trang khi sidebar mở
    });
    
    // Xử lý sự kiện đóng sidebar
    function closeSidebar() {
      sidebar.classList.remove('open');
      overlay.classList.remove('visible');
      document.body.style.overflow = ''; // Cho phép cuộn trang khi đóng sidebar
    }
    
    closeBtn.addEventListener('click', closeSidebar);
    overlay.addEventListener('click', closeSidebar);
    
    // Xử lý sự kiện nhấp vào các mục menu
    const menuLinks = document.querySelectorAll('.sidebar-menu-item');
    
    menuLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Xóa class active khỏi tất cả liên kết
        menuLinks.forEach(l => l.classList.remove('active'));
        
        // Thêm class active cho liên kết được nhấp
        this.classList.add('active');
        
        // Lấy ID mục tiêu
        const targetId = this.getAttribute('href');
        const targetSection = document.querySelector(targetId);
        
        if (targetSection) {
          // Đóng sidebar
          closeSidebar();
          
          // Đợi một chút để sidebar đóng trước khi cuộn
          setTimeout(() => {
            // Cuộn đến section
            window.scrollTo({
              top: targetSection.offsetTop - 80,
              behavior: 'smooth'
            });
          }, 300);
        } else {
          console.log('Section not found:', targetId);
        }
      });
    });
    
    // Đánh dấu menu active khi cuộn
    window.addEventListener('scroll', function() {
      const scrollPosition = window.scrollY;
      
      // Tìm section đang hiển thị
      const sections = document.querySelectorAll('#combo, #fusion, #sashimi, #zensai-khai-vi, #agemono-mon-chien, #yaki-mon-nuong, #sushi, #bento, #donburi, #mi-udon-ramen, #extra, #thuc-uong');
      
      sections.forEach(section => {
        if (!section) return;
        
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          const id = section.getAttribute('id');
          
          // Xóa class active khỏi tất cả liên kết
          menuLinks.forEach(link => link.classList.remove('active'));
          
          // Thêm class active cho liên kết tương ứng
          const activeLink = document.querySelector(`.sidebar-menu-item[href="#${id}"]`);
          if (activeLink) {
            activeLink.classList.add('active');
          }
        }
      });
    });
    
    // Thêm log để debug
    console.log('Fixed sidebar initialized for menu collection page');
  }
});
